<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <fa-icon class="prompt-icon text-primary" [icon]="faQuestionCircle"></fa-icon>
</div>
<div class="modal-body">
    <p>{{ message }}</p>
</div>
<div class="modal-footer">
    <a class="btn btn-primary" [href]="targetUrl" target="_blank" rel="noopener" (click)="openedInNewTab()">Open in a new tab</a>
    <button id="btnLeaveMeeting" type="button" class="btn btn-secondary" (click)="leave()">Leave the meeting</button>
    <button id="btnStayInMeeting" type="button" class="btn btn-link" (click)="stay()">Stay here</button>
</div>
